<template>
    <div>
        <b-modal v-model="showModal" hide-footer ok-only ok-title="Ok" centered size="lg" title="Detail Pendalaman Register"
            @hidden="onModalClose" @ok="onModalConfirm">
            <div>
                <div class="card p-1 border border-1 rounded mb-1" style="box-shadow: none;">
                    <div class="card-body p-0">
                        <div class="row mb-1">
                            <div class="col-12">
                                <h4 class="font-weight-bold text-uppercase text-primary">Data BMD</h4>
                            </div>
                        </div>
                        <hr />
                        <div class="row mb-1">
                            <div class="col-12">
                                <div class="font-weight-bold text-muted">Guid Aset</div>
                            </div>
                            <div class="col-12">
                                <div>
                                    {{ formDatas.guid_aset || '-' }}
                                </div>
                            </div>
                        </div>
                        <div class="row mb-1">
                            <div class="col-12">
                                <div class="font-weight-bold text-muted">Nomor Register</div>
                            </div>
                            <div class="col-12">
                                <div>
                                    {{ formDatas.noreg_108 || '-' }}
                                </div>
                            </div>
                        </div>
                        <div class="row mb-1">
                            <div class="col-12">
                                <div class="font-weight-bold text-muted">Kode Barang</div>
                            </div>
                            <div class="col-12">
                                <div>
                                    {{ formDatas.kobar_108 || '-' }}
                                </div>
                            </div>
                        </div>
                        <div class="row mb-1">
                            <div class="col-12">
                                <div class="font-weight-bold text-muted">Nama Barang</div>
                            </div>
                            <div class="col-12">
                                <div>
                                    {{ formDatas.nabar_108 || '-' }}
                                </div>
                            </div>
                        </div>
                        <div class="row mb-1">
                            <div class="col-12">
                                <div class="font-weight-bold text-muted">Tanggal Perolehan</div>
                            </div>
                            <div class="col-12">
                                <div>
                                    <span>{{ parserValue('dateOnly', formDatas.tgl_oleh) || '-' }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-1">
                            <div class="col-12">
                                <div class="font-weight-bold text-muted">Total Harga</div>
                            </div>
                            <div class="col-12">
                                <div>
                                    {{ `${new Intl.NumberFormat('id-ID', {
                                        maximumFractionDigits: 2,
                                    }).format(formDatas.total_harga)}` }}
                                </div>
                            </div>
                        </div>
                        <div class="row mb-1">
                            <div class="col-12">
                                <div class="font-weight-bold text-muted">Bahan</div>
                            </div>
                            <div class="col-12">
                                <div>
                                    {{ formDatas.nama_bahan || '-' }}
                                </div>
                            </div>
                        </div>
                        <div class="row mb-1">
                            <div class="col-12">
                                <div class="font-weight-bold text-muted">Merk</div>
                            </div>
                            <div class="col-12">
                                <div>
                                    {{ formDatas.merk || '-' }}
                                </div>
                            </div>
                        </div>
                        <div class="row mb-1">
                            <div class="col-12">
                                <div class="font-weight-bold text-muted">Tipe</div>
                            </div>
                            <div class="col-12">
                                <div>
                                    {{ formDatas.tipe || '-' }}
                                </div>
                            </div>
                        </div>
                        <div class="row mb-1">
                            <div class="col-12">
                                <div class="font-weight-bold text-muted">Nomor Chasis</div>
                            </div>
                            <div class="col-12">
                                <div>
                                    {{ formDatas.nochasis || '-' }}
                                </div>
                            </div>
                        </div>
                        <div class="row mb-1">
                            <div class="col-12">
                                <div class="font-weight-bold text-muted">Nomor Mesin</div>
                            </div>
                            <div class="col-12">
                                <div>
                                    {{ formDatas.nomesin || '-' }}
                                </div>
                            </div>
                        </div>
                        <div class="row mb-1">
                            <div class="col-12">
                                <div class="font-weight-bold text-muted">Nomor Polisi</div>
                            </div>
                            <div class="col-12">
                                <div>
                                    {{ formDatas.nopol || '-' }}
                                </div>
                            </div>
                        </div>
                        <div class="row mb-1">
                            <div class="col-12">
                                <div class="font-weight-bold text-muted">Nomor BPKB</div>
                            </div>
                            <div class="col-12">
                                <div>
                                    {{ formDatas.nobpkb || '-' }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card p-1 border border-1 rounded" style="box-shadow: none;">
                    <div class="card-body p-0">
                        <div class="row mb-1">
                            <div class="col-12">
                                <h4 class="font-weight-bold text-uppercase text-primary">Hasil Pendalaman Register</h4>
                            </div>
                        </div>
                        <hr />
                        <b-overlay :show="isLoadGetData" variant="light" opacity="0.85" blur="2px" rounded="sm"
                            style="min-height: 20vh;">
                            <template v-if="formDataHS.jenis_pendalaman == 'biaya-biaya'">
                                <FormBiayaReadonly :fD="formDataHS.biaya_biaya" :disabled="true" />
                            </template>
                            <template v-else-if="formDataHS.jenis_pendalaman == 'fisik-tidak-ditemukan'">
                                <FormFisikNotFoundReadonly :fD="formDataHS.fisik_tidak_ditemukan" :disabled="true" />
                            </template>
                        </b-overlay>
                    </div>
                </div>
                <!--  dikirim | dikembalikan | disetujui  -->
                <div
                    v-if="['dikembalikan'].includes(formDatas.status_hasil_sensus) && formDataHS.hasil_sensus_bmd_id && $can('Buat', 'b-pendalaman-register')">
                    <div class="card knowledge-base-bg text-center bg-light-primary" style="box-shadow: none;">
                        <div class="card-body ">
                            <div class="d-flex justify-content-center" style="gap: 5px">
                                <b-button v-b-tooltip.hover title="Koreksi Data Pendalaman" variant="primary"
                                    class="mt-25 mt-md-0" :to="{
                                        name: 'bPendalamanRegisterUpdate',
                                        params: { id: formDataHS.hasil_sensus_bmd_id },
                                    }">
                                    <feather-icon icon="Edit3Icon" size="15" class="mr-25" />
                                    <span class="font-weight-bold">Koreksi Pendalaman</span>
                                </b-button>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-for="(item, i) in formDataHS.workflow" :key="i" class="card mb-1">
                    <div class="card-header border-bottom">
                        <h4 class="font-weight-bold text-uppercase">
                            Validasi P3B
                        </h4>
                    </div>
                    <div class="card-body pt-1">
                        <div class="row">
                            <div class="col-12 col-md-4 col-lg-4">
                                <div>
                                    <span class="font-weight-bolder">Divalidasi Oleh</span>
                                </div>
                                <div>
                                    <span>{{ item.action_by || '-' }}</span>
                                </div>
                            </div>
                            <div class="col-12 col-md-4 col-lg-4">
                                <div>
                                    <span class="font-weight-bolder">Divalidasi Pada</span>
                                </div>
                                <div>
                                    <span>{{ parserValue('dateTime', item.action_at) || '-' }}</span>
                                </div>
                            </div>
                            <div class="col-12 col-md-4 col-lg-4">
                                <div>
                                    <span class="font-weight-bolder">Status Validasi</span>
                                </div>
                                <span class="badge" :class="badgeActionWf(item.action)">{{
                                    item.action || '-'
                                }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div>
                                    <span class="font-weight-bolder">Catatan Validasi</span>
                                </div>
                                <div>
                                    <span>
                                        {{ item.catatan || '-' }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
  
<script>
import { ref, onMounted, watchEffect } from '@vue/composition-api'
import vSelect from "vue-select";
import { id as localeId } from "vee-validate/dist/locale/id";
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import Cleave from 'vue-cleave-component'
import { parserValue } from '@/libs/helper'
import { VBTooltip, BButton } from 'bootstrap-vue'
import pendalamanRegister from "@/composables/b/pendalamanRegister";
import FormBiayaReadonly from './FormBiayaReadonly.vue'
import FormFisikNotFoundReadonly from './FormFisikNotFoundReadonly.vue'

import masterBRef from "@/composables/master/masterBRef";

export default {
    props: {
        show: { Boolean, required: true },
        dataModal: {
            type: Object,
            default: () => ({}),
        },
    },
    setup(props, context) {
        localize('id', localeId);
        const g = context.root;
        const showModal = ref(false);
        const formDatas = ref({});
        const formDataHS = ref({})
        const dsKib = ref([]);
        const isLoadGetData = ref(false);
        const getData = () => {
            isLoadGetData.value = true;
            formDataHS.value = {};
            let params = {
                filter_platform: 'web',
                filter_kategori: 'tercatat',
                hasil_sensus_bmd_id: props.dataModal.hasil_sensus_bmd_id,
            };
            pendalamanRegister.getDetailPendalamanRegister(g, params).then(res => {
                formDataHS.value = res.data;
                isLoadGetData.value = false;
            }).catch(err => {
                isLoadGetData.value = false;
                console.log(err)
            });

        };

        watchEffect(() => {
            showModal.value = props.show;
            formDatas.value = props.dataModal
            if (props.show) {
                getData();
            }
        });

        return {
            isLoadGetData,
            showModal,
            formDatas,
            formDataHS,
            parserValue
        }
    },

    components: {
        ValidationProvider,
        ValidationObserver,
        FormBiayaReadonly,
        FormFisikNotFoundReadonly,

    },
    methods: {
        onModalClose() {
            this.$emit('closeDialog');
        },
        onModalConfirm() {
            console.log('Modal confirmed ' + this.showModal);
        },
        badgeActionWf(action) {
            if (action == 'setuju') {
                return 'badge-light-success';
            } else {
                return 'badge-light-danger';
            }
        },
    },
    directives: {
        'b-tooltip': VBTooltip,
    },
    data() {
        return {
            required,
        }
    },
}
</script>
  